
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 
 import {ObcToggleButtonGroup as ObcToggleButtonGroupElement} from '@oicl/openbridge-webcomponents/dist/components/toggle-button-group/toggle-button-group.js';
 
 
 

 
 export const ObcToggleButtonGroup = createComponent({
   react: React,
   tagName: 'obc-toggle-button-group',
   elementClass: ObcToggleButtonGroupElement,
   events: {
     
     onValue: 'value' as EventName<CustomEvent<{value: string, previousValue: string}>>,
   }
  });
 
 